__turbopack_context__.v({
  "country_tag_search_wrapper": "ACYJLa_country_tag_search_wrapper",
  "country_wrapper": "ACYJLa_country_wrapper",
  "curved_corner_bottom_right": "ACYJLa_curved_corner_bottom_right",
  "curved_corner_top_right": "ACYJLa_curved_corner_top_right",
  "help_block_inner": "ACYJLa_help_block_inner",
});
